const REFUSED_CREDENTIAL_CODE = 'AUTH_INVALID_TOKEN';
export const SESSION_ENDED_CODE = 'AUTH_SESSION_ENDED';

function errorCode(data: unknown): string | null {
  if (typeof data !== 'object' || data === null || !('error' in data)) return null;

  const inner = data.error;
  if (typeof inner !== 'object' || inner === null || !('code' in inner)) return null;

  return typeof inner.code === 'string' ? inner.code : null;
}

export function isRefusedCredential(status: unknown, data: unknown): boolean {
  return status === 401 && errorCode(data) === REFUSED_CREDENTIAL_CODE;
}

export function isSessionEnded(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  if (!('status' in error) || !('data' in error)) return false;

  return error.status === 401 && errorCode(error.data) === SESSION_ENDED_CODE;
}
